import { mixinActions, mixinMutations, mixinState, mixinGetters } from '../../mixins/vuexCRUD'

const getters = {
  ...mixinGetters(),
  trailers: (state) => state.items,
}

const state = {
  ...mixinState(),
  path: '/trailers',
}

const mutations = mixinMutations()

const actions = mixinActions()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
